<template>
  <div v-if="data" class="text-static-default-hi">
    <Breadcrumb :category="data.category" />

    <TheMainContent>
      <RevContainer class="bg-surface-default-low pb-56 md:pb-72">
        <h1 class="heading-1 mt-32 text-center">
          {{ data.category.pageTitle }}
        </h1>
        <template v-if="!isNewComparisonPageActive">
          <div class="mb-56">
            <ComparisonForm
              :autocomplete-config="data.algoliaConfig.searchBox"
            />
          </div>

          <RevDivider />
        </template>

        <SuggestedCategories class="mt-56" />
      </RevContainer>
    </TheMainContent>

    <AdditionalContent :content="data.content" :custom-content-first="false" />
  </div>
</template>

<script lang="ts" setup>
import { useAsyncData, useRuntimeConfig } from '#imports'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevContainer } from '@ds/components/Container'
import { RevDivider } from '@ds/components/Divider'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'

import AdditionalContent from '../../components/AdditionalContent/AdditionalContent.vue'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb.vue'
import ComparisonForm from '../../components/ComparisonForm/ComparisonForm.vue'
import SuggestedCategories from '../../components/SuggestedCategories/SuggestedCategories.vue'
import { useCurrentCategory } from '../../composables/useCurrentCategory'
import { useModelsComparisonHead } from '../../composables/useModelsComparisonHead'

const currentCategory = useCurrentCategory()
const $httpFetch = useHttpFetch()
const country = useMarketplace().market.countryCode
const experiments = useExperiments()
const { FF_NEW_COMPARE_PAGE_ENABLED_COUNTRY_CODES } = useRuntimeConfig().public
const logger = useLogger()

const { data, error } = await useAsyncData(
  `model-comparison-category-${currentCategory}`,
  () => {
    return $httpFetch('/bm/models-comparison/categories/:category', {
      pathParams: { category: String(currentCategory) },
    })
  },
)

if (error.value) {
  logger.error('[ModelComparisonSearch] Failed to fetch', {
    error: error.value,
    owners: ['bot-squad-content-front'],
  })
}

const isNewComparisonPageActive =
  FF_NEW_COMPARE_PAGE_ENABLED_COUNTRY_CODES.includes(country) ||
  experiments['experiment.comparisonV2'] === 'enabled'

useModelsComparisonHead(() => data.value?.content)
</script>
